<template>
  <div
      class="toast-container position-fixed p-3"
      :class="toastPositionClass" @mouseover="onToastMouseOver" @mouseout="onToastMouseOut">
    <div
        :id="propId"
        class="toast align-items-center"
        role="alert"
        :class="this.toastClass"
        aria-live="assertive"
        aria-atomic="true"
        :data-bs-delay="this.delayValue"
        :data-bs-autohide="this.autoHide">
      <div class="toast-header" v-if="$slots.header">
        <slot name="header"></slot>
      </div>
      <div class="toast-body">
        <slot name="body"></slot>
        <slot name="actions"></slot> <!-- Action buttons will go here -->
      </div>
      <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
          @click="onToastClose"
          v-if="propShowClose"
      ></button>
    </div>
  </div>
</template>
<script>
import {Toast} from 'bootstrap';

export default {
  emits: ['onToastClose', 'onToastHidden', 'onToastMouseOver', 'onToastMouseOut'],
  props: {
    propId: String,
    propTrigger: Boolean,
    propShowClose: Boolean,
    propType: {type: String, default: ''},
    propBorderClass: {type: String, default: ''},
    propAutoHide: {type: Boolean, default: true},
    propDelay: Number,
    propStatus: Boolean,
    propPosition: {
      type: String,
      default: 'top'
    },
    propRegisterClickOutside: {type: Boolean, default: false}
  },
  watch: {
    propTrigger(newValue) {
      let toast = this.toastObject;

      if (toast !== null)
        if (newValue) {
          toast.show();
          this.addClickOutsideListener();
          this.addListenerOnHidden();
        } else {
          toast.hide();
          this.removeClickOutsideListener();
        }
    }
  },
  methods: {
    onToastClose() {
      this.$emit('onToastClose');
      this.removeClickOutsideListener();
    },
    onToastMouseOver(e) {
      this.$emit('onToastMouseOver', e);
    },
    onToastMouseOut(e) {
      this.$emit('onToastMouseOut', e);
    },
    addClickOutsideListener() {
      if (this.propRegisterClickOutside === true)
        document.addEventListener('click', this.handleClickOutside);
    },
    addListenerOnHidden() {
      const toastEl = document.getElementById(this.propId);
      if (toastEl)
        toastEl.addEventListener('hidden.bs.toast', () => {
          this.$emit('onToastHidden')
        });
    },
    removeClickOutsideListener() {
      if (this.propRegisterClickOutside === true)
        document.removeEventListener('click', this.handleClickOutside);
    },
    handleClickOutside(event) {
      const toastEl = document.getElementById(this.propId);
      if (toastEl && !toastEl.contains(event.target)) {
        this.onToastClose();
      }
    }
  },
  mounted() {
    if (this.propStatus) {
      const toastEl = document.getElementById(this.propId);
      let toast = Toast.getOrCreateInstance(toastEl);

      if (toast) {
        toast.dispose();
        toast = new Toast(toastEl);
        toast.show();
        this.addClickOutsideListener();
      }
    }
  },
  computed: {
    toastObject() {
      const toastEl = document.getElementById(this.propId);
      if (!toastEl) return null;

      let toastInstance = Toast.getOrCreateInstance(toastEl);
      return toastInstance !== null && toastInstance !== undefined ? toastInstance : null;
    },
    toastClass() {
      return `${this.toastBackgroundClass} ${this.toastBorderClass}`
    },
    toastBackgroundClass() {
      return this.propType !== '' ? `text-bg-${this.propType}` : '';
    },
    toastBorderClass() {
      return this.propBorderClass !== '' ? `border-${this.propBorderClass}` : 'border-0';
    },
    autoHide() {
      return this.propAutoHide === true ? 'true' : 'false';
    },
    delayValue() {
      return this.propDelay ?? 3000;
    },
    toastPositionClass() {
      let positions = {
        'top-left': 'top-0 start-0',
        'top': 'top-0 start-50 translate-middle-x',
        'top-right': 'top-0 end-0',
        'middle-left': 'top-50 start-0 translate-middle-y',
        'middle': 'top-50 start-50 translate-middle',
        'middle-right': 'top-50 end-0 translate-middle-y',
        'bottom-left': 'bottom-0 start-0',
        'bottom': 'bottom-0 start-50 translate-middle-x',
        'bottom-right': 'bottom-0 end-0'
      }
      return positions.hasOwnProperty(this.propPosition) ? positions[this.propPosition] : positions['top'];
    }
  },
  beforeUnmount() {
    this.removeClickOutsideListener();
  }
};
</script>
